import React, { useEffect, useState } from "react";
import { auth, googleProvider, ALLOWED_DOMAIN, ADMIN_EMAIL, GUEST_EMAIL } from "./firebase";
import { signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import StudentView from "./StudentView";
import AdminView from "./AdminView";
import "./App.css";

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  const handleLogin = async () => {
    setError("");
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const email = result.user.email;
      if (!email.endsWith("@" + ALLOWED_DOMAIN) && email !== GUEST_EMAIL) {
  await signOut(auth);
  setError("北海学園大学のGoogleアカウント（@hgu.jp）でログインしてください。");
}
    } catch (e) {
      setError("ログインに失敗しました。");
    }
  };

  const handleLogout = () => signOut(auth);

  if (loading) return <div className="center-screen"><p>読み込み中...</p></div>;

  if (!user) {
    return (
      <div className="center-screen">
        <div className="login-card">
          <h1>📝 教室外スピーキング活動報告</h1>
          <p className="subtitle">CS-BⅠ・Ⅱ（浦野クラス）</p>
          <button className="btn-google" onClick={handleLogin}>
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" width={20} />
            HGUアカウントでログイン
          </button>
          {error && <p className="error">{error}</p>}
        </div>
      </div>
    );
  }

  const isAdmin = user.email === ADMIN_EMAIL;
  const isAllowed = isAdmin || user.email === GUEST_EMAIL || user.email.endsWith("@hgu.jp");

  return (
    <div className="app">
      <header className="app-header">
        <span className="header-title">📝 教室外スピーキング活動報告</span>
        <div className="header-right">
          {isAdmin && <span className="badge-admin">管理者</span>}
          <span className="user-name">{user.displayName}</span>
          <button className="btn-logout" onClick={handleLogout}>ログアウト</button>
        </div>
      </header>
      <main>
        {isAdmin ? <AdminView user={user} /> : <StudentView user={user} />}
      </main>
    </div>
  );
}
